import { IBannerContent, IQnAAuthor, IQnAReplyItem } from '../sharedTypes/sharedTypes';

export interface IQnAListPayload {
  userId: string;
  realmId: string;
  limit: number;
  page: number;
  desc: boolean;
  includeReplies: boolean;
  sortBy?: string;
  tags?: string;
}

export interface IQnAUser {
  updatedByTool: string;
  createdByTool: string;
  id: string;
  osUpdatedAt: Date;
  politicallyExposed: boolean;
  verified: boolean;
  primaryPhoneNumber: string;
  osCreatedAt: Date;
  primaryRealm: string;
  isBlackListed: boolean;
  cpv: any[];
  userType: any[];
  additionalDetails: any[];
  investmentDetails: any[];
  contactDetails: ContactDetails;
  mediaDetails: MediaDetails;
  businessProfile: UserBusinessProfile;
}

export interface ContactDetails {
  address: Address[];
  contactNumber: string[];
  id: string;
}

export interface Address {
  pincode: string;
  state: string;
  district: string;
  village: string;
  subdivision: string;
}

export interface UserBusinessProfile {
  businessName: string;
}

export interface MediaDetails {
  id: string;
  media: Media[];
  type: string;
}

export interface Media {
  mediaUrl: string;
  type: string;
  key: string;
  name: string;
  visibility: string;
}

export interface Tag {
  name: string;
  url: string;
}
export interface StreamingPlaylist {
  files: string[];
  id: number;
  playlistURL: string;
  redundancies: string[];
  segmentsSha256URL: string;
  type: number;
}

interface Refresh {
  isRefresh: boolean;
  interval: number;
  frequency: string;
}

interface CardDetail {
  language: string;
  name: string;
  description: string;
}

interface WorkflowMediaDetail {
  id: string;
  type: string;
  visibility: string;
  mediaId: string;
  location: string;
  mediaUrl: string;
  fileName: string;
  mediaType: string;
  mediaVisibility: string;
  mediaFormat: string;
  media_lat: number;
  media_lon: number;
}

export interface GeoLocation {
  lat: number;
  lon: number;
}

export interface IQnACommentRequestPayload {
  id?: string;
  userId?: string;
  realmId?: string;
  limit?: number;
  page?: number;
}

export interface IQnADetailPayload {
  userId?: string;
  realmId?: string;
  id: string | undefined;
}

export interface IQnACommentResponseItem {
  id: string;
  timestamp: number;
  type: string;
  appid: string;
  parentid: string;
  creatorid: string;
  updated: null;
  name: string;
  tags: null;
  votes: number;
  version: number;
  stored: boolean;
  indexed: boolean;
  cached: boolean;
  comment: string;
  hidden: boolean;
  authorName: string;
  objectURI: string;
  plural: string;
}

export interface IQnACommentList {
  id: string;
  timestamp: number;
  type: string;
  appid: string;
  parentid: string;
  creatorid: string;
  updated: null;
  name: string;
  tags: null;
  votes: number;
  version: number;
  stored: boolean;
  indexed: boolean;
  cached: boolean;
  comment: string;
  hidden: boolean;
  authorName: string;
  objectURI: string;
  plural: string;
  createdAt?: number;
  updatedBy?: string;
  createdBy?: string;
  updatedByTool?: string;
  createdByTool?: string;
  updatedAt?: number;
  
}

export interface ICardActionData {
  contentType: string;
  content: Content;
  mediaDetails: MediaDetail[];
  eventNamePrefix: string;
  props?: Prop[];
}

export interface Prop {
  key: string;
  value: number;
}

export interface MediaDetail {
  type: string;
  mediaURL?: string;
  preview_url?: string;
  blurhash?: string;
  mediaUrl?: string;
}

export interface Content {
  videoTitle: string;
  authorName: string;
  viewCount: number;
  videoLink: string;
  playlistId?: string;
  videoid?: string;
  mediaDetails?: PlaylistMediaDetail[];
  name: string;
  videoCount: number;
  eventId?: string;
}

export interface PlaylistMediaDetail {
  type: string;
  mediaURL: null;
}

export interface IExchangeTokenResponse {
  statusCode: number;
  message: string;
  data: IExchangeTokenData;
}

export interface IExchangeTokenData {
  mastodonToken: string;
  peerTube: IStreamData;
  qnaUser: IQnaUser;
}

export interface IStreamData {
  token_type: string;
  access_token: string;
  refresh_token: string;
  expires_in: number;
  refresh_token_expires_in: number;
}

export interface IQnaUser {
  originalName: string;
  originalPicture: null;
  lastseen: number;
  location: string;
  latlng: null;
  status: string;
  aboutme: string;
  badges: string;
  groups: string;
  upvotes: number;
  downvotes: number;
  comments: number;
  picture: string;
  website: string;
  favtags: any[];
  favspaces: any[];
  modspaces: any[];
  expertspaces: any[];
  spaces: string[];
  replyEmailsEnabled: boolean;
  commentEmailsEnabled: boolean;
  favtagsEmailsEnabled: boolean;
  anonymityEnabled: boolean;
  darkmodeEnabled: boolean;
  yearlyVotes: number;
  quarterlyVotes: number;
  monthlyVotes: number;
  weeklyVotes: number;
  customBadges: any[];
  pendingEmail: null;
  editorRoleEnabled: boolean;
  id: string;
  timestamp: number;
  type: string;
  appid: string;
  parentid: null;
  creatorid: string;
  updated: number;
  name: string;
  tags: any[];
  votes: number;
  version: number;
  stored: boolean;
  indexed: boolean;
  cached: boolean;
  properties: IQnAProps;
  user: IQnAUser;
}

export interface IQnAProps {
  createdAt: number;
  updatedBy: string;
  createdBy: string;
  updatedByTool: string;
  createdByTool: string;
  updatedAt: number;
}

export interface IQnAUser {
  id: string;
  timestamp: number;
  type: string;
  appid: string;
  parentid: null;
  creatorid: null;
  updated: number;
  name: string;
  tags: null;
  votes: number;
  version: number;
  stored: boolean;
  indexed: boolean;
  cached: boolean;
  identifier: string;
  groups: string;
  active: boolean;
  twoFA: boolean;
  email: string;
  currency: null;
  picture: string;
  idpIdToken: null;
  idpAccessToken: null;
  idpRefreshToken: null;
  objectURI: string;
  plural: string;
  identityProvider: string;
}
export interface ICategoryResponse {
  data: ICategory[];
}

export interface ICategory {
  id: number;
  name: string;
  regionalName: IRegionalName[];
}

export interface IRegionalName {
  name: string;
  language: string;
}

export interface ICropByCategoryResponse {
  data: ICropByCategory[];
}

export interface ICropByCategory {
  id: string;
  name: string;
  alternateName?: string[];
  scientificName?: string;
  media: ICropRegistryMedia[];
  cropDetail?: ICropDetail[];
}

export interface ICropDetail {
  cropId: string;
  name: string;
  language: string;
}
export interface ICropRegistryMedia {
  type: ICropRegistryMediaType;
  mediaUrl: string;
}
export enum ICropRegistryMediaType {
  BackGroundImage = 'BackGroundImage',
  CropIconImage = 'CropIconImage',
  CropImage = 'CropImage',
}
export interface IAnimalPreferenceResponse {
  data: IAnimalPreferenceData[];
}

export interface IAnimalPreferenceData {
  id: string;
  name: string;
  languageName: string;
  mediaUrl: string;
}

export enum IPreferenceType {
  ANIMAL = 'ANIMAL',
  CROP = 'CROP',
}

export enum IGlobalSearchTab {
  STREAM = 'STREAM',
  FEED = 'FEED',
  QNA = 'QNA',
}
export interface IAnsweredQuestionState {
  isModAnswered: boolean;
  isBottomSheetOpened: boolean;

  isBannerClosed: boolean;
}
